/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SimpleAccessToken } from "./SimpleAccessToken";
export const SimpleAccessTokenResponse = core.serialization.object({
    data: SimpleAccessToken,
});
